import React from "react";
import "./Tariff.css";

const tariffs = [
  { type: "MINI", seating: "4+1", description: "Compact and efficient choice for a quick city ride", image: "/wagon-r.png", rateNonAC: "Rs. 11/km", rateAC: "Rs. 12/km",buttonText: "Book Now" },
  { type: "SEDAN", seating: "4+1", description: "Travel in style with our premium and spacious cars", image: "nissansunny.png", rateNonAC: "Rs. 12/km", rateAC: "Rs. 13/km",buttonText: "Book Now" },
  { type: "MUV", seating: "8+1", description: "The perfect people mover for your joint family travel", image: "tavera.png", rateNonAC: "Rs. 14/km", rateAC: "Rs. 15/km",buttonText: "Book Now" },
  { type: "MUV PRIME", seating: "7+1", description: "Classy and comfortable ride for the entire family group", image: "xylo.png", rateNonAC: "Rs. 14/km", rateAC: "Rs. 15/km",buttonText: "Book Now" },
  { type: "SUV", seating: "7+1", description: "Experience a world where luxury meets comfort and style", image: "innova.png", rateNonAC: "-", rateAC: "Rs. 17/km",buttonText: "Book Now" },
  //{ type: "TEMPO", seating: "12+1", description: "Spacious, safe, and comfortable.", image: "tempo.png", rateNonAC: "-", rateAC: "Rs. 25/km" },
];

const Tariff = () => {
  return (
    <section className="tariff-section" id="tariff">
      <div className="container">
        <h2 className="tariff-header">Pricing & Tariff</h2>
        <div className="tariff-grid">
          {tariffs.map((t, idx) => (
            <div className="tariff-card" key={idx}>
              <div className="tariff-image">
                <img src={t.image} alt={t.type} />
              </div>
              <h3 className="tariff-type">{t.type}</h3>
              <p className="tariff-seating">Seating {t.seating}</p>
              <p className="tariff-desc">{t.description}</p>
              <div className="tariff-rates">
                {t.rateNonAC && <p>Non-AC: <strong>{t.rateNonAC}</strong></p>}
                {t.rateAC && <p>AC: <strong>{t.rateAC}</strong></p>}
                <button className="cab-btn" onClick={() => {document.getElementById('contact').scrollIntoView({behavior:"smooth"});}}>{t.buttonText}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tariff;
